export default "/kiban/_next/static/images/bottom_none-e1020353aed66572f23345b81fdb6347.png";